import { useRef, useState } from "react";
import { Button, HStack, Text, Spinner, useToast } from "@chakra-ui/react";
import { Paperclip } from "lucide-react";
import { FieldShell, type FieldControlProps } from "./FieldShell";
import { validateFile } from "../formValidation";

export function FileField({ field, fieldValue, onChange, onUploadFile, showError, errMsg }: FieldControlProps) {
  const toast = useToast();
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const value = fieldValue?.value ?? "";

  const handleUpload = async (file: File) => {
    const fileError = validateFile(field, file);
    if (fileError) {
      toast({ title: fileError, status: "error", duration: 6000, isClosable: true });
      return;
    }
    setUploading(true);
    try {
      const result = await onUploadFile(field.id, file);
      onChange(field.id, result.download_url);
    } catch {
      // useSubmission já mostra o toast de erro
    } finally {
      setUploading(false);
    }
  };

  return (
    <FieldShell field={field} showError={showError} errMsg={errMsg}>
      <input
        ref={inputRef}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) handleUpload(file);
        }}
      />
      <HStack>
        <Button
          size="sm"
          leftIcon={<Paperclip size={14} />}
          variant="outline"
          isLoading={uploading}
          onClick={() => inputRef.current?.click()}
        >
          {value ? "Trocar arquivo" : "Selecionar arquivo"}
        </Button>
        {uploading && <Spinner size="sm" />}
        {value && !uploading && <Text fontSize="sm" color="green.500">Arquivo enviado</Text>}
      </HStack>
    </FieldShell>
  );
}